import React, { useEffect } from 'react';
import { useSetFullBreadcrumbTrail } from '../../context/BreadcrumbContext';
import CadastroEventoImportarMalhaAereo from './CadastroEventoImportarMalhaAereo';

/**
 * O Rascunho de Malha (`/rascunhoMalhaAereo`): a tela da malha no modo rascunho, como a Sugestão de Voos é o modo
 * sugestão. É uma ferramenta do Aéreo, sem evento nem solicitação: o upload só lê a planilha, e o Salvar guarda a
 * tela neste navegador (`util/rascunhoMalha`). Nada vai ao sistema, e nada trava.
 */
export default function RascunhoMalhaAereo() {
    const setFullTrail = useSetFullBreadcrumbTrail();
    useEffect(() => {
        setFullTrail([{ path: '/aereo', label: 'Aéreo' }, { path: '/rascunhoMalhaAereo', label: 'Rascunho de Malha' }]);
    }, [setFullTrail]);

    return <CadastroEventoImportarMalhaAereo match={{ params: {} }} rascunho />;
}
